import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1279e1eb"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Loading... ")

import i18n from '@/locale/i18n';

export default /*#__PURE__*/_defineComponent({
  __name: 'XPageDataTable',
  props: {
    headerShow: {
        type: Boolean,
        default: false,
        require: false
    }
},
  setup(__props) {

const props = __props

const t = i18n.global.t;


return (_ctx: any,_cache: any) => {
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createBlock(_component_DataTable, {
    rowsPerPageOptions: [10, 30, 50],
    class: _normalizeClass(props.headerShow ? 'x-table-header' : 'x-table'),
    paginator: true,
    rows: 10,
    paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
    currentPageReportTemplate: "{first} - {last} / {totalRecords}",
    stripedRows: ""
  }, _createSlots({
    empty: _withCtx(() => [
      _createTextVNode(_toDisplayString(_unref(t)("REGISTRATION.NO_GUEST")), 1)
    ]),
    loading: _withCtx(() => [
      _hoisted_1
    ]),
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 2
  }, [
    (props.headerShow)
      ? {
          name: "header",
          fn: _withCtx(() => [
            _renderSlot(_ctx.$slots, "header")
          ])
        }
      : undefined
  ]), 1032, ["class"]))
}
}

})